import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

interface PmsIntegrationCredentials {
  email: string;
  password: string;
  username: string;
}

export default class Pmsintegration extends Model {
  [Type] = 'pmsintegration' as const;

  @attr declare credentials: PmsIntegrationCredentials;
  @attr('string') declare description: string;
}
